import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import MultiSelect from '../../common/TextField/dropDown';

const UserLocationModal = ({
  locationModal,
  data,
  handleLocationClose,
  handleLocation,
}) => {
  const [locationSelectedValue, setLocationSelectedValue] = useState([]);

  const updateLocationValue = (target) => {
    if (target.action === 'add') {
      setLocationSelectedValue((previousValue) => {
        return [...previousValue, target.value];
      });
    } else if (target.action === 'remove') {
      const newData = locationSelectedValue.filter(
        (item) => item.id !== target.value.id
      );
      setLocationSelectedValue([...newData]);
    }
  };

  useEffect(() => {
    const selectedValue = data.locatoinList
      .filter((value) => value.isSelected === true)
      .map((value) => {
        return {
          id: value.locationId,
          name: value.locationName,
        };
      });
    setLocationSelectedValue(selectedValue);
    return () => {};
  }, [data]);

  return (
    <>
      <div id="userLocationModal">
        <Modal size="md" show={locationModal} onHide={handleLocationClose}>
          <Modal.Header closeButton>
            <Modal.Title>{data.name}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-sm-12">
                <MultiSelect
                  name={'locationValue'}
                  divClass="col-sm-12"
                  id={'updateCovidStatus'}
                  value={locationSelectedValue}
                  options={data.locatoinList?.map((value) => {
                    return {
                      id: value.locationId,
                      name: value.locationName,
                    };
                  })}
                  multiple={true}
                  updateValue={updateLocationValue}
                  isObject={true}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => handleLocation(locationSelectedValue)}
            >
              Save
            </Button>
            <Button variant="secondary" onClick={handleLocationClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default UserLocationModal;
